import React from 'react';
import useAlertStore from "../../store/alertStore";
import './alerter.css';

const Alert = () => {

    const {removeAlert,alerts} = useAlertStore();

    return (
        <div className={"Alerter fixed-bottom"}>
            {
                alerts.map((alert)=>
                    <div key={`alert-${alert.uid}`} className={`alert alert-${alert.type} mb-2`} onClick={()=>removeAlert(alert.uid)} role="alert">
                        {alert.message}
                    </div>
                )
            }
        </div>
    );
};

export default Alert;